"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.samplingAiClient = samplingAiClient;
const sampling_1 = require("./sampling");
function samplingAiClient(server, maxTokens = 4096) {
    return {
        async complete(messages) {
            const systemMessages = messages.filter(m => m.role === 'system');
            const nonSystem = messages.filter(m => m.role !== 'system');
            const systemPrompt = systemMessages.map(m => m.content).join('\n\n') || undefined;
            const samplingMessages = nonSystem.map(m => ({
                role: m.role === 'assistant' ? 'assistant' : 'user',
                content: { type: 'text', text: m.content },
            }));
            return (0, sampling_1.requestSampling)(server, samplingMessages, systemPrompt, maxTokens);
        },
    };
}
